import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import type { ComponentProps } from "react";

export default function LinkedinIcon(props: Omit<ComponentProps<typeof FontAwesomeIcon>, "icon">) {
  return <FontAwesomeIcon {...props} icon={faLinkedin} />;
}
